// ----------------------------------------------------------------------------
// Component: Accordion
// ----------------------------------------------------------------------------
//
// Generic accordion component.
//
// Requires the following structure:
// .js-accordion__item
//     .js-accordion__button
//     .js-accordion__content
//
// When the button is clicked, 'isOpen' class is added/removed for all three
// elements.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// Styles
import './accordion.scss';

// -------------------------------------
// Variables
// -------------------------------------

var ACCORDION               = '.js-accordion';
var ACCORDION_BUTTON        = '.js-accordion__button';
var ACCORDION_ITEM          = '.js-accordion__item';
var ACCORDION_CONTENT       = '.js-accordion__content';
var ACCORDION_TITLE         = '.accordion__title';

// Constant trigger classes
var OPEN_CLASS              = 'is-open';

// -------------------------------------
// Helper Functions
// -------------------------------------

function objectifyAccordionButton(accordionButton) {
    return {
        $button:       accordionButton,
        $item:         accordionButton.parents(ACCORDION_ITEM),
        $title:        accordionButton.parents(ACCORDION_TITLE),
        $content:      accordionButton.parents(ACCORDION_TITLE).siblings(ACCORDION_CONTENT),
        isOpening:     !accordionButton.hasClass(OPEN_CLASS),
        $container:    accordionButton.closest(ACCORDION),
        $button_group: accordionButton.closest(ACCORDION).find(ACCORDION_BUTTON)
    };
}

function handleAccordion(accordion) {
    // Close all open accordions within same container
    accordion.$container.find('.' + OPEN_CLASS).removeClass(OPEN_CLASS);
    accordion.$container.find(ACCORDION_CONTENT)
        .css('overflow', 'hidden')
        .attr('hidden', true);
    accordion.$container.find(ACCORDION_BUTTON)
        .attr('aria-expanded', 'false');
    accordion.$container.find(ACCORDION_CONTENT + ' a')
        .attr('tabindex', -1);

    if (accordion.isOpening) {
        // Open the clicked (or first) accordion
        accordion.$button
            .add(accordion.$item)
            .add(accordion.$content)
            .addClass(OPEN_CLASS);

        accordion.$button.attr('aria-expanded', 'true');
        accordion.$content.attr('hidden', false);
        accordion.$content.find('a').attr('tabindex', null);

        // Allow content overflow after open animation
        setTimeout(function() {
            accordion.$content.css('overflow', 'visible');
        }, 200);
    }
}

// -------------------------------------
// Hooks
// -------------------------------------

$(document).ready(function() {
    // Initialize accessibility attributes
    $(ACCORDION_CONTENT + ' a').attr('tabindex', -1);

    // Toggle on click or keyboard
    $(ACCORDION_BUTTON).on('click keydown', function(e) {
        var accordion = objectifyAccordionButton($(e.target));

        if (e.type === 'click') {
            e.preventDefault();
            if ($(e.target).hasClass('js-accordion__button--contidioned')) return;
            handleAccordion(accordion);
        } else if (e.type === 'keydown') {
            var key = e.which.toString();
            if (key.match(/35|36|38|40/)) {
                e.preventDefault();
                var index = $.inArray(e.target, accordion.$button_group);
                var length = accordion.$button_group.length;
                var newIndex;
                switch (key) {
                    case '38': newIndex = (index + length - 1) % length; break;
                    case '40': newIndex = (index + length + 1) % length; break;
                    case '35': newIndex = length - 1; break;
                    case '36': newIndex = 0; break;
                }
                accordion.$button_group[newIndex].focus();
            }
        }
    });

    // Open the first item only within the PDP tabs on load (desktop only)
    if (window.matchMedia('(min-width: 680px)').matches) {
        $('.accordion--pdp-tabs').each(function() {
            var $group = $(this);
            var $firstBtn = $group.find(ACCORDION_BUTTON).first();
            if ($firstBtn.length) {
                handleAccordion(objectifyAccordionButton($firstBtn));
            }
        });
    }
});
